// ==================== src/layouts/HomeLayout.tsx ====================
import React from "react";
import WealthNavbar from "./WealthNavbar";
import WealthFooter from "./WealthFooter";

interface WealthMethodLayoutProps {
  children: React.ReactNode;
}

export const WealthMethodLayout: React.FC<WealthMethodLayoutProps> = ({
  children,
}) => {
  return (
    <div className="min-h-screen flex flex-col">
      <WealthNavbar />
      <main className="flex-grow">{children}</main>
      <WealthFooter />
    </div>
  );
};

export default WealthMethodLayout;
